export default "<div class=\"tc-filter-container\">\r\n  <tc-filter-store [storeKey]=\"gridStoreKey\"></tc-filter-store>\r\n</div>\r\n";